import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';
import {
  type NoteSuggestionsState,
  type PersonalisationDocumentDiff,
  type PersonalisationProtocolState,
} from '../note-suggestions/personalisation-state';

export const noteSuggestionsAtomFamily = atomFamily(() =>
  atom<NoteSuggestionsState>(null)
);

export const personalisationProtocolAtomFamily = atomFamily(() =>
  atom<PersonalisationProtocolState>(null)
);

export const personalisationDocumentDiffAtomFamily = atomFamily(() =>
  atom<PersonalisationDocumentDiff>(null)
);
